import { app } from '../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {

    $stateProvider.state('public.google-marketplace', {
        url: '/googlemarketplace/:domain',
        component: 'googleMarketplaceLogin',
        resolve: {domain},
    });
}

/** @ngInject */
function domain($stateParams) {
    return $stateParams.domain;
}



// WEBPACK FOOTER //
// ./src/portal/states/public/google-marketplace-login/google-marketplace-login.state.js